// extracted by mini-css-extract-plugin
module.exports = {"templates":"templates--3Tm_b","listicon":"listicon--2_o8u"};